import { CSS_PREFIX } from './constants-es';

export interface IClassNames {
  [key: string]: any;
}

const hasOwn = {}.hasOwnProperty;

/**
 * Wrapper around classname function
 * @param params classname params array of any
 */
function classNames(...params: Array<any>): string {
  const classes = [];
  for (const param of params) {
    const argType = typeof param;
    if (argType === 'string' || argType === 'number') {
      classes.push(param);
    } else if (Array.isArray(param)) {
      /* istanbul ignore else */ if (param.length) {
        const inner = classNames.apply(null, param);
        /* istanbul ignore else */ if (inner) {
          classes.push(inner);
        }
      }
    } else if (argType === 'object') {
      if (param.toString !== Object.prototype.toString) {
        classes.push(param.toString());
      } else {
        for (const key in param) {
          /* istanbul ignore else */ if (hasOwn.call(param, key) && param[key]) {
            classes.push(key);
          }
        }
      }
    }
  }

  return classes.join(' ');
}

const styles = (...args: any): string => {
  const classes = classNames(...args);
  const prefixed = classes
    .split(' ')
    .filter((cl: string) => cl.length > 0)
    .map((cl: string) => CSS_PREFIX + cl)
    .join(' ');

  return prefixed;
};

export const makeClassNames = (classes: IClassNames): IClassNames =>
  Object.keys(classes).reduce((cn, key) => {
    // @ts-ignore
    cn[key] = styles(classes[key]);

    return cn;
  }, {});

export default styles;
